import React from 'react';

interface Props {
    logData: DownloadResult;
}

export const LogDetails = ({ logData }: Props): JSX.Element => (
        <div className="w-full">
            <pre className="bg-black break-all whitespace-pre-wrap text-white rounded-lg p-4">
                {logData.parsed
                    ? JSON.stringify(logData.parsed, null, 4)
                    : logData?.raw?.toString()}
            </pre>
        </div>
    );
